import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "join",
  class: "py-12 bg-white"
}
const _hoisted_2 = { class: "container mx-auto px-4" }
const _hoisted_3 = { class: "max-w-4xl mx-auto" }
const _hoisted_4 = { class: "rounded-xl shadow-lg overflow-hidden border border-gray-200" }
const _hoisted_5 = ["src", "height"]
const _hoisted_6 = { class: "mt-8 text-center text-sm text-gray-500" }
const _hoisted_7 = ["href"]

import { ref, onMounted, onUnmounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'contactUs',
  setup(__props) {

const formUrl = ref('https://dcnf604l23wl.feishu.cn/share/base/form/shrcnCOV6E7LcmdnTiecGKtNzFf')
const iframeHeight = ref(600)

const updateIframeHeight = () => {
  iframeHeight.value = window.innerHeight > 800 ? 800 : window.innerHeight - 200
}

onMounted(() => {
  updateIframeHeight()
  window.addEventListener('resize', updateIframeHeight)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateIframeHeight)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center mb-8" }, [
          _createElementVNode("h2", { class: "text-3xl font-bold text-gray-900 mb-4" }, "联系我们"),
          _createElementVNode("p", { class: "text-gray-600" }, "填写表单与我们取得联系")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("iframe", {
              src: formUrl.value,
              class: "w-full",
              height: iframeHeight.value,
              frameborder: "0",
              allowfullscreen: "",
              sandbox: "allow-scripts allow-same-origin allow-forms allow-popups"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, [
              _cache[0] || (_cache[0] = _createTextVNode("如果表单无法正常显示，请")),
              _createElementVNode("a", {
                href: formUrl.value,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "text-blue-600 hover:underline"
              }, "点击此处", 8, _hoisted_7),
              _cache[1] || (_cache[1] = _createTextVNode("在新窗口打开"))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})